module.exports = __webpack_public_path__ + "static/media/Outing.f65bab3c.jpg";